import Config from "@/utils/config"
import {
	login
} from "@/api/auth/login"
import {
	adList
} from "@/api/website"
import {
	noticesList
} from "@/api/cms/notice"
import {
	floors,
	floatLayer,
	apiDefaultSearchWords
} from "@/api/pc"
import {
	mapGetters
} from "vuex"
import {
	couponList,
	receiveCoupon
} from "@/api/coupon"
import {
	goodsPage,
	timeList
} from "@/api/seckill"
import {
	goodsSkuPage
} from "@/api/goods/goods"
import CountDown from "vue2-countdown"

export default {
	name: "index",
	components: {
		CountDown
	},
	data: () => {
		return {
			loadingAd: true,
			loadingFloor: true,
			adList: [],
			adLeftList: [],
			adRightList: [],
			noticeList: [],
			couponList: [],
			floorList: [],
			floatLayer: {
				is_show: false,
				link: {
					url: ""
				}
			},
			indexFloatLayerNum: 0,
			shopApplyUrl: Config.baseUrl + "/shop/login/register",
			shopCenterUrl: Config.baseUrl + "/shop/index/index",
			storeUrl: Config.baseUrl + "/store",
			isSub: false,
			siteId: 0,
			listData: [],
			seckillTimeMachine: {
				currentTime: 0,
				startTime: 0,
				endTime: 0
			},
			seckillText: "距离结束",
			backgroundColor: "", // 顶部banner背景颜色
			// 悬浮搜索
			searchType: "goods",
			searchTypeText: "商品",
			keyword: "",
			defaultSearchWords: "",
			isShow: false,
			goodsList:[]
		}
	},
	watch: {
		searchType() {
			this.searchTypeText = this.searchType == "goods" ? "商品" : "店铺"
		}
	},
	created() {
		console.log('gh',this.addonIsExit)
		console.log('gh',this.city)
		
		// 检查URL参数suid并保存到缓存
		this.checkAndSaveSuid()
		
		this.getAdList()
		this.getNotice()
		this.getBigAdList()
		this.getSmallAdList()
		if(this.city.id > 0){
			this.getIndexGoodsList();
		}else{
			this.getFloors();
			this.getFloatLayer();
			if(this.addonIsExit && this.addonIsExit.seckill == 1){
				this.getTimeList();
			}
			this.getCanReceiveCouponQuery();
		}
	
		// this.getFloatLayer()
		this.$store.dispatch("site/siteInfo") // 站点信息
		this.getDefaultSearchWords() // 默认搜索类型
		// if(this.addonIsExit && this.addonIsExit.seckill == 1){
		// 	this.getTimeList()
		// }
		// this.getCanReceiveCouponQuery()
	},
	mounted() {
		window.addEventListener("scroll", this.handleScroll)
	},
	computed: {
		...mapGetters(["defaultHeadImage", "addonIsExit", "defaultGoodsImage", "member", "siteInfo", "cartCount","city"]),
		optionLeft() {
			return {
				direction: 2,
				limitMoveNum: 1
			}
		},
		// 供应商入驻按钮显示逻辑
		showSupplierApply() {
			if (!this.member || !this.member.shop) {
				return true; // 如果没有用户信息或shop为空，显示供应商入驻
			}
			
			// 如果shop是空数组，显示供应商入驻
			if (Array.isArray(this.member.shop) && this.member.shop.length === 0) {
				return true;
			}
			
			// 如果shop_status不是1，显示供应商入驻
			if (this.member.shop.shop_status !== 1) {
				return true;
			}
			
			return false;
		},
		// 供应商入口按钮显示逻辑
		showSupplierCenter() {
			if (!this.member || !this.member.shop) {
				return false; // 如果没有用户信息或shop为空，不显示供应商入口
			}
			
			// 如果shop是空数组，不显示供应商入口
			if (Array.isArray(this.member.shop) && this.member.shop.length === 0) {
				return false;
			}
			
			// 如果shop_status是1，显示供应商入口
			if (this.member.shop.shop_status === 1) {
				return true;
			}
			
			return false;
		},
		// 采购商入驻按钮显示逻辑
		showProcurementApply() {
			// 如果用户等级大于1，不显示采购商入驻按钮
			if (this.member && this.member.member_level > 1) {
				return false;
			}
			return true;
		},
		// 采购商信息按钮显示逻辑
		showProcurementInfo() {
			// 如果用户等级大于1，显示采购商信息按钮
			if (this.member && this.member.member_level > 1) {
				return true;
			}
			return false;
		}
	},
	methods: {
		/**
		 * 检查URL参数suid并保存到缓存
		 */
		checkAndSaveSuid() {
			const urlParams = new URLSearchParams(window.location.search);
			const suid = urlParams.get('suid');
			
			if (suid) {
				// 保存suid到localStorage
				localStorage.setItem('suid', suid);
				console.log('SUID已保存到缓存:', suid);
			}
		},
		/*
		 * 解决秒杀组件复制出来的没有点击事件
		 */
		clickProps(e){
			if(!e.target.dataset.obj){ return }
			let item = JSON.parse(e.target.dataset.obj);
			this.$router.pushToTab('/promotion/seckill-' + item.id)
		},
		countDownS_cb() {},
		countDownE_cb() {
			this.seckillText = "活动已结束"
		},
		getIndexGoodsList() {
			goodsSkuPage({
				})
				.then(res => {
					this.goodsList = res.data.list;
				})
				.catch(err => {
				})
		},
		getAdList() {
			adList({
					keyword: "NS_PC_INDEX"
				})
				.then(res => {
					this.adList = res.data.adv_list
					for (let i = 0; i < this.adList.length; i++) {
						if (this.adList[i].adv_url) this.adList[i].adv_url = JSON.parse(this.adList[i].adv_url)
					}
					this.backgroundColor = this.adList[0].background
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		handleChange(curr, pre) {
			this.backgroundColor = this.adList[curr].background
		},
		/* 秒杀图片处理 */
		goodsImg(imgStr) {
			let imgs = imgStr.split(',');
			return imgs[0] ? this.$util.img(imgs[0], { size: 'mid' }) : this.defaultGoodsImage;
		},
		/**
		 * 广告位大图
		 */
		getBigAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_LEFT"
				})
				.then(res => {
					this.adLeftList = res.data.adv_list
					for (let i = 0; i < this.adLeftList.length; i++) {
						if (this.adLeftList[i].adv_url) this.adLeftList[i].adv_url = JSON.parse(this.adLeftList[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		/**
		 * 广告位小图
		 */
		getSmallAdList() {
			adList({
					keyword: "NS_PC_INDEX_MID_RIGHT"
				})
				.then(res => {
					this.adRightList = res.data.adv_list
					for (let i = 0; i < this.adRightList.length; i++) {
						if (this.adRightList[i].adv_url) this.adRightList[i].adv_url = JSON.parse(this.adRightList[i].adv_url)
					}
					this.loadingAd = false
				})
				.catch(err => {
					this.loadingAd = false
				})
		},
		getNotice() {
			noticesList({
					page: 1,
					page_size: 5,
					receiving_type: "web"
				})
				.then(res => {
					this.noticeList = res.data.list
				})
				.catch(err => err)
		},
		//获取优惠券列表
		getCanReceiveCouponQuery() {
			couponList({
					activeName: "second",
					site_id: this.siteId
				})
				.then(res => {
					let data = res.data
					this.couponList = []
					if (data != null) {
						for (let i = 0; i < data.list.length; i++) {
							if (i < 5) {
								this.couponList.push(data.list[i])
							}
						}
						this.couponList.forEach(v => {
							v.useState = 0
						})
					}
				})
				.catch(err => {})
		},
		/**
		 * 领取优惠券
		 */
		receiveCoupon(item, index) {
			if (this.isSub) return
			this.isSub = true

			var data = {
				site_id: item.site_id,
				activeName: "second",
				platformcoupon_type_id: item.platformcoupon_type_id
			}

			receiveCoupon(data)
				.then(res => {
					var data = res.data
					let msg = res.message
					if (res.code == 0) {
						msg = "领取成功"
						this.$message({
							message: msg,
							type: "success"
						})
					} else {
						this.$message({
							message: msg,
							type: "warning"
						})
					}
					let list = this.couponList
					if (res.data.is_exist == 1) {
						for (let i = 0; i < list.length; i++) {
							if (list[i].platformcoupon_type_id == item.platformcoupon_type_id) {
								list[i].useState = 1
							}
						}
					} else {
						for (let i = 0; i < list.length; i++) {
							if (list[i].platformcoupon_type_id == item.platformcoupon_type_id) {
								list[i].useState = 2
							}
						}
					}

					this.isSub = false
					this.$forceUpdate()
				})
				.catch(err => {
					if (err.message == 'token不存在') {
						this.$router.pushToTab('/login')
					} else {
						this.$message.error(err.message);
					}
					this.isSub = false
				})
		},
		/**
		 * 点击优惠券
		 */
		couponTap(item, index) {
			if (item.useState == 0) this.receiveCoupon(item, index)
			else this.toGoodsList(item)
		},
		/**
		 * 去购买
		 */
		toGoodsList(item) {
			if (item.use_scenario != 1) {
				this.$router.push({
					path: "/list",
					query: {
						platformcouponTypeId: item.platformcoupon_type_id
					}
				})
			} else {
				this.$router.push("/list")
			}
		},
		/**
		 * 限时秒杀
		 */
		getTimeList() {
			timeList()
				.then(res => {
					if (res.code == 0 && res.data) {
						let time = new Date(res.timestamp * 1000)
						let currentTimes = time.getHours() * 60 * 60 + time.getMinutes() * 60 + time.getSeconds()
						res.data.list.forEach((v, k) => {
							if (v.seckill_start_time <= currentTimes && currentTimes < v.seckill_end_time) {
								let seckillId = v.id
								this.getGoodsList(seckillId)

								let endTime = parseInt(time.getTime() / 1000) + (v.seckill_end_time - currentTimes)
								this.seckillTimeMachine = {
									currentTime: res.timestamp,
									startTime: res.timestamp,
									endTime: endTime
								}
							}
						})
					}
				})
				.catch(err => {
					this.$message.error(err.message)
				})
		},
		/**
		 * 秒杀商品
		 */
		getGoodsList(id) {
			goodsPage({
					page_size: 0,
					seckill_id: id,
					site_id: this.siteId
				})
				.then(res => {
					if (res.code == 0 && res.data.list) {
						this.listData = res.data.list
					}
				})
				.catch(err => {})
		},
		/**
		 * 图片加载失败
		 */
		imageError(index) {
			this.listData[index].sku_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adLeftImageError(index) {
			this.adLeftList[index].adv_image = this.defaultGoodsImage
		},
		/**
		 * 图片加载失败
		 */
		adRightImageError(index) {
			this.adRightList[index].adv_image = this.defaultGoodsImage
		},
		getFloors() {
			floors()
				.then(res => {
					this.floorList = res.data;
					console.log(res,'res')
				})
				.catch(err => {
					console.log(err)
				})
		},
		getFloatLayer() {
			floatLayer()
				.then(res => {
					if (res.code == 0 && res.data) {
						this.floatLayer = res.data
						this.floatLayer.link = JSON.parse(this.floatLayer.url)
						// 弹框形式，首次弹出 1，每次弹出 0

						if (!this.floatLayer.img_url) return

						if (parseInt(this.floatLayer.number) == 1) {
							var index_popwindow_count = this.$store.state.app.indexFloatLayerNum;
							if (index_popwindow_count == '' || index_popwindow_count == 1) {
								this.floatLayer.is_show = true
								this.$store.commit("app/SET_FLOAT_LAYER", 1)
							}
						} else if (parseInt(this.floatLayer.number) == 0) {
							this.floatLayer.is_show = true
							this.$store.commit("app/SET_FLOAT_LAYER", 0)
						}
					}
				})
				.catch(err => err)
		},
		closeFloat() {
			this.floatLayer.is_show = false
			this.$forceUpdate()
			this.$store.commit("app/SET_FLOAT_LAYER", -1)
		},
		// 监听滚动条
		handleScroll() {
			var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop

			if (scrollTop >= 680) {
				this.isShow = true
			} else {
				this.isShow = false
			}
		},
		destroyed() {
			// 离开该页面需要移除这个监听的事件，不然会报错
			window.removeEventListener("scroll", this.handleScroll)
		},
		/**
		 * 默认搜索类型（goods/shop）
		 */
		getDefaultSearchWords() {
			apiDefaultSearchWords({}).then(res => {
				if (res.code == 0 && res.data.words) {
					this.defaultSearchWords = res.data.words
				}
			})
		},
		handleCommand(command) {
			this.searchType = command
		},
		search() {
			if (this.searchType == 1) {
				this.$router.push({
					path: "/list",
					query: {
						keyword: this.keyword
					}
				})
			} else {
				this.$router.push({
					path: "/shop/list",
					query: {
						keyword: this.keyword
					}
				})
			}
		},
		// 处理供应商入驻按钮点击
		handleSupplierApply() {
			// 检查用户是否登录
			if (!this.member) {
				this.$message.warning('请先登录');
				this.$router.push('/login');
				return;
			}
			
			// 检查shop状态
			if (this.member.shop && this.member.shop.shop_status !== undefined) {
				const shopStatus = this.member.shop.shop_status;
				
				if (shopStatus === 2) {
					// shop_status = 2 表示审核中，只提示不跳转
					this.$message.info('您的申请正在审核中');
					return;
				} else if (shopStatus === 1) {
					// shop_status = 1 表示已通过审核，提示用户
					this.$message.info('您已是供应商，请前往供应商中心');
					return;
				}
			}
			
			// 检查shop_apply状态
			if (this.member.shop && this.member.shop.shop_apply && this.member.shop.shop_apply.apply_state !== undefined) {
				const applyState = this.member.shop.shop_apply.apply_state;
				
				if (applyState < 0) {
					// 审核未通过，提示并跳转
					this.$message.error('您的审核未通过，请修改申请');
					setTimeout(() => {
						this.$router.push('/member/supplier_settle');
					}, 1000);
				} else if (applyState > 0) {
					// 正在审核中，只提示不跳转
					this.$message.info('您的申请正在审核中');
				} else {
					// apply_state = 0 或其他情况，正常跳转
					this.$router.push('/member/supplier_settle');
				}
			} else {
				// 没有shop_apply信息，正常跳转
				this.$router.push('/member/supplier_settle');
			}
		},
		
		// 处理采购商入驻按钮点击
		handleProcurementApply() {
			// 检查用户是否登录
			if (!this.member) {
				this.$message.warning('请先登录');
				this.$router.push('/login');
				return;
			}
			
			// 检查procurement状态
			if (this.member.procurement) {
				// 如果procurement不是空数组且有数据
				if (!Array.isArray(this.member.procurement) || this.member.procurement.length > 0) {
					const procurementStatus = Number(this.member.procurement.status);
					
					if (procurementStatus === 1) {
						// 审核中进入会员中心，回显已提交的入驻资料
						this.$router.push('/member/settle?tab=procurement');
						return;
					} else if (procurementStatus === -1) {
						// status = -1 表示审核未通过，进入会员中心修改资料
						this.$message.error('您的申请未通过');
						setTimeout(() => {
							this.$router.push('/member/settle?tab=procurement&type=reapply');
						}, 1500);
						return;
					}
				}
			}
			
			// procurement是空数组或不存在，进入会员中心填写申请
			this.$router.push('/member/settle?tab=procurement');
		},
		
		// 处理采购商信息按钮点击
		handleProcurementInfo() {
			// 跳转到采购商入驻信息页面
			this.$router.push('/member/settle?tab=procurement');
		}
	}
}
